import {AnalyticsService} from "../../third-party-services/analytics/analytics-service";
import {ACTION_TYPES} from "../consts";
import {AnalyticsEventHandler} from "../../infrastructure/handlers/analytics-event-handler";
import {MatchDetailsClickEvent} from "../models/events/match-details-click-event";

export class MatchDetailsClickEventHandler extends AnalyticsEventHandler {
  type = ACTION_TYPES.matchDetailsClick;
  analyticsService: AnalyticsService;

  static injectables = [AnalyticsService];

  constructor(analyticsService: AnalyticsService) {
    super(analyticsService);

    this.eventType = MatchDetailsClickEvent;
  }

  async action(params) {
    const clickEvent = new this.eventType(params, this.getScreen(params.currentLinkModelName));

    this.analyticsService.createEvent(clickEvent);
  }
}
